/* eslint-disable camelcase */
export enum UserPreferencesTypes {
  GET_USER_PREFERENCES_REQUEST = '@userPreferences/GET_USER_PREFERENCES_REQUEST',
  GET_USER_PREFERENCES_SUCCESS = '@userPreferences/GET_USER_PREFERENCES_SUCCESS',
  GET_USER_PREFERENCES_FAILURE = '@userPreferences/GET_USER_PREFERENCES_FAILURE',
  SAVE_USER_PREFERENCES_REQUEST = '@userPreferences/SAVE_USER_PREFERENCES_REQUEST',
  SAVE_USER_PREFERENCES_SUCCESS = '@userPreferences/SAVE_USER_PREFERENCES_SUCCESS',
  SAVE_USER_PREFERENCES_FAILURE = '@userPreferences/SAVE_USER_PREFERENCES_FAILURE',
  DELETE_USER_PREFERENCES_REQUEST = '@userPreferences/DELETE_USER_PREFERENCES_REQUEST',
  DELETE_USER_PREFERENCES_SUCCESS = '@userPreferences/DELETE_USER_PREFERENCES_SUCCESS',
  DELETE_USER_PREFERENCES_FAILURE = '@userPreferences/DELETE_USER_PREFERENCES_FAILURE',
}

export interface UserPreferenceData {
  created_at: string;
  updated_at: string;
  id: number;
  preference_id: number;
  user_id: number;
}

export interface RequestState {
  get_user_preferences: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  save_user_preferences: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  delete_user_preferences: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface UserPreferencesState {
  readonly userPreferences: Array<UserPreferenceData>;
  readonly request: RequestState;
}
